import { Button, Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";

const toolbarButtonSx = {
  color: "#1976D2",
  borderColor: "#1976D2",
  "&:hover": {
    borderColor: "#1565C0",
    backgroundColor: "rgba(25, 118, 210, 0.04)",
  },
};

import type { TFunction } from "i18next";

export interface CustomToolbarProps {
  title?: string;
  onClickAction?: () => void;
  t: TFunction;
}

export const CustomToolbar = ({ title, onClickAction, t }: CustomToolbarProps) => (
  <Tooltip title={title}>
    <Button variant="outlined" onClick={onClickAction} startIcon={<Add />} sx={toolbarButtonSx}>
      {t("register")}
    </Button>
  </Tooltip>
);
